<template>
    <div>
        <!-- 右侧悬浮侧边栏 -->
        <div class="comm_sider fnt_30">
            <ul class="fixed">
                <li @click="serviceClick">
                    <a href="javascript:void(0)"><i class="icon-kefu"></i></a>
                    <span class="tooltip-text">客服</span>
                </li>
                <li @click="shoppingCartClick" ref="cartIcon" class="has-badge">
                    <a href="javascript:void(0)">
                        <i class="icon-gouwuche"></i>
                        <div class="badge" v-if="cartCount > 0" :class="{ shaking: isShake }">
                            {{ cartCount }}
                        </div>
                    </a>
                    <span class="tooltip-text">购物车</span>
                </li>
                <li @click="quickOrderClick">
                    <a href="javascript:void(0)"><i class="icon-dinggoufushu"></i></a>
                    <span class="tooltip-text">快速订购</span>
                </li>
                <li @click="myComparisonClick">
                    <a href="javascript:void(0)"><i class="icon-duibi"></i></a>
                    <span class="tooltip-text">对比</span>
                </li>
                <li @click="scrollToTop">
                    <a href="javascript:void(0)" class="toTop"><i class="icon-fanhuidingbu-"></i></a>
                    <span class="tooltip-text">返回顶部</span>
                </li>
            </ul>
        </div>

        <!-- 飞入购物车小球 -->
        <div v-if="showFlyBall" class="fly-ball" :style="{ left: flyX + 'px', top: flyY + 'px', opacity: flyOpacity }">
            <i class="el-icon-shopping-cart-2"></i>
        </div>
    </div>
</template>

<script>
import '@/assets/font/iconfont.css'
import Bus from "@/utils/bus"; // 兄弟组件事件总线，用于通知客服组件打开面板
export default {
    name: 'CartFloatBar',
    props: {
        cartCount: { type: Number, default: 0 },
        badge: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            showFlyBall: false,
            flyX: 0,
            flyY: 0,
            flyOpacity: 1,
            isShake: false
        }
    },
    methods: {
        startFly(startElement) {
            const start = startElement.getBoundingClientRect();
            const end = this.$refs.cartIcon.getBoundingClientRect();

            this.flyX = start.left + start.width / 2 - 15;
            this.flyY = start.top + start.height / 2 - 15;
            this.showFlyBall = true;
            this.flyOpacity = 1;

            setTimeout(() => {
                this.flyX = end.left + end.width / 2 - 15;
                this.flyY = end.top + 10;
                this.flyOpacity = 0;
            }, 20);

            setTimeout(() => {
                this.showFlyBall = false;
                this.shakeBadge();
            }, 600);
        },

        shakeBadge() {
            this.isShake = true;
            setTimeout(() => {
                this.isShake = false;
            }, 500);
        },

        serviceClick() {
            Bus.$emit('openCustomerService');
        },

        shoppingCartClick() {
            this.$router.push('/product/shoppingCart');
        },
        
        quickOrderClick() {
            this.$router.push('/member/celerityOrder');
        },
        
        myComparisonClick() {
            this.$router.push('/product/productContrast');
        },

        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
    }
}
</script>

<style scoped>
.comm_sider .fixed li {
    position: relative;
}

.badge {
    position: absolute;
    top: 4px;
    right: 8px;
    background: #ff3333;
    color: #fff;
    font-size: 10px;
    border-radius: 50%;
    min-width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 1;
}

.shaking {
    animation: leftRightShake 0.5s ease-in-out;
}

@keyframes leftRightShake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-3px); }
    50% { transform: translateX(3px); }
    75% { transform: translateX(-2px); }
}

.fly-ball {
    position: fixed;
    width: 30px;
    height: 30px;
    background: #4080ff;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    transition: all 0.6s cubic-bezier(0.25, 0.1, 0.25, 1);
    pointer-events: none;
}

/* ========== 优化后的 hover 提示文字 ========== */
.tooltip-text {
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 12px;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(4px);
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 6px;
    white-space: nowrap;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    opacity: 0;
    visibility: hidden;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
    z-index: 100;
}

/* 小三角箭头 */
.tooltip-text::after {
    content: '';
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent rgba(0, 0, 0, 0.8);
}

/* hover 显示 */
.comm_sider .fixed li:hover .tooltip-text {
    opacity: 1;
    visibility: visible;
    transform: translateY(-50%) translateX(-4px);
}

/* 有角标的购物车项，提示文字向右多留间距，避免与角标重叠 */
.comm_sider .fixed li.has-badge .tooltip-text {
    margin-right: 28px;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .tooltip-text {
        font-size: 11px;
        padding: 4px 8px;
        margin-right: 8px;
    }
    .tooltip-text::after {
        border-width: 4px;
    }
    .comm_sider .fixed li.has-badge .tooltip-text {
        margin-right: 24px;
    }
}
</style>